export const barberSHopDatas = {
  gyor: {
    location: "9022 Győr, Móricz Zsigmond rakpart 8",
    phone: "+36203278062",
    email: "info@artistsalons.hu",
    mapImage: "/salons/gyor.png",
    barbers: [
      {
        name: "Varga Kristóf",
        imgPath: "/barber_profiles/rounded/varga.png",
      },
      {
        name: "Tóth Máté",
        imgPath: "/barber_profiles/rounded/toth.png",
      },
      {
        name: "Kecskeméti Ferenc",
        imgPath: "/barber_profiles/rounded/kecso.png",
      },
    ],
    openHours: {},
    imgPath: "",
    link: "https://www.fresha.com/a/a-r-t-i-s-t-gyor-gyor-moricz-zsigmond-rakpart-hsqml4zk",
  },
  moson: {
    location: "9200 Mosonmagyaróvár, Magyar utca 4",
    phone: "+36203278062",
    email: "info@artistsalons.hu",
    mapImage: "/salons/moson.png",
    barbers: [
      {
        name: "Kecskeméti Ferenc",
        imgPath: "/barber_profiles/rounded/kecso.png",
      },
      {
        name: "Demeter Adorján",
        imgPath: "/barber_profiles/rounded/demeter.png",
      },
      {
        name: "Jónás Manó",
        imgPath: "/barber_profiles/rounded/mano.png",
      },
      {
        name: "Viktor",
        imgPath: "/barber_profiles/rounded/noProfile.png",
      },
      {
        name: "Mixtai István",
        imgPath: "/barber_profiles/rounded/noProfile.png",
      },
    ],
    openHours: {},
    imgPath: "",
    link: "https://www.fresha.com/a/artist-barber-shop-mosonmagyarovar-magyar-utca-4-kr8qumem",
  },
  csorna: {
    location: "9300 Csorna, Soproni út 63",
    phone: "+36203278062",
    email: "info@artistsalons.hu",
    mapImage: "/salons/csorna.png",
    barbers: [
      {
        name: "Kecskeméti Ferenc",
        imgPath: "/barber_profiles/rounded/kecso.png",
      },
      {
        name: "Gyarmati Denisz",
        imgPath: "/barber_profiles/rounded/denisz.png",
      },
      {
        name: "Iváncsis Kristóf",
        imgPath: "/barber_profiles/rounded/ivancsis.png",
      },
      {
        name: "Tar Bálint",
        imgPath: "/barber_profiles/rounded/tar.png",
      },
      {
        name: "Jónás Manó",
        imgPath: "/barber_profiles/rounded/mano.png",
      },
    ],
    openHours: {},
    imgPath: "",
    link: "https://www.fresha.com/hu/a/kecso-hair-barber-shop-csorna-soproni-ut-63-esv2xp2x?fbclid=IwZXh0bgNhZW0CMTAAAR1jYLlEoKeaDnKgW-MWT1T1NPxF7-DbJfW2LgKSf7yWu2vEe_k6ffvkXr8_aem_8phTmygI0xWKMlZ0d237mQ",
  },
  fertod: {
    location: "HAMAROSAN!",
    phone: "HAMAROSAN!",
    email: "",
    mapImage: "/salons/fertod.png",
    barbers: [],
    openHours: {},
    imgPath: "",
    link: "",
  },
};
